// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5bccf9b1","732":"943cbf4a"}[chunkId] + ".chunk.js";
};